import { render, staticRenderFns } from "./CompactBanner.vue?vue&type=template&id=37744de1&scoped=true"
import script from "./CompactBanner.vue?vue&type=script&lang=js"
export * from "./CompactBanner.vue?vue&type=script&lang=js"
import style0 from "./CompactBanner.vue?vue&type=style&index=0&id=37744de1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37744de1",
  null
  
)

export default component.exports